// removed by extract-text-webpack-plugin
module.exports = {"xsmall":"only screen and (min-width: 375px)","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","retina":"(-webkit-min-device-pixel-ratio: 2)","title":"title-A9TNU","align--right":"align--right-3MfNd","align--center":"align--center-1v1qs","rule":"rule-2-aAv","align--left":"align--left-U58Qs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/app-page/shared/Title/_title.css
// module id = 1176
// module chunks = 1